import { Flex, StrapiLink, Text } from "@theme/components";

import type { StrapiLinkInterface } from "@ms/gatsby-site/src/types/strapi";

export const FooterLegalLinks = ({
  legalLinks,
  isBlog,
}: {
  legalLinks: StrapiLinkInterface[];
  isBlog: boolean;
}) => (
  <Flex
    as="ul"
    sx={{
      flexDirection: ["column", null, "row"],
      flexWrap: "wrap",
      alignItems: "center",
      justifyContent: ["center", null, "flex-start"],
      listStyle: "none",
      px: 0,
      mx: 0,
      order: ["1", null, "2"],
    }}
  >
    {legalLinks.map((link, index) => (
      <Flex
        key={link.label}
        as="li"
        sx={{
          alignItems: "center",
          textAlign: ["center", null, null, "left"],
        }}
      >
        <StrapiLink
          linkVariant="textLinkLevel3"
          {...link}
          isBlog={isBlog}
          sx={{ textDecoration: "none", variant: "text.sansMicro02Regular" }}
        />
        {index !== legalLinks.length - 1 && (
          <Text
            sx={{
              display: ["none", null, "inline"],
              lineHeight: 1,
              color: "grey300",
              mx: "s200",
            }}
          >
            |
          </Text>
        )}
      </Flex>
    ))}
  </Flex>
);
